import PropTypes from 'prop-types'

/**
 * LabeledField - A reusable wrapper for an input or dropdown with a descriptor above.
 * Usage:
 * <LabeledField label="Make">
 *   <input ... />
 * </LabeledField>
 * <LabeledField label="Year">
 *   <select>...</select>
 * </LabeledField>
 */
export default function LabeledField({ label, children, className = '', validationError }) {
  return (
    <div className={`flex flex-col mb-4 ${className}`}>
      <label className="mb-1 text-[14px] leading-[20px] font-[300]" style={{ color: 'var(--Grays-Gray, #5D5D5D)' }}>{label}</label>
      {children}
      {validationError && (
        <div className="mt-2 text-[14px] leading-[20px] font-[300] text-error-500">
          {validationError}
        </div>
      )}
    </div>
  )
}

LabeledField.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  validationError: PropTypes.string,
}
